var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNorthStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 70,
    viewBox: "0 0 81 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 68C2 68 21.4332 36.9998 30.0348 37C38.6364 37.0002 54 68 54 68",
    stroke: "white",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 56.0001C48 56.0001 54 47.5003 59.5 47.0001C65 46.5 79 62.0001 79 62.0001",
    stroke: "white",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20.2424C40 20.2424 46.9238 20.3071 49.4131 16.6893C51.6924 13.3767 51.6924 2 51.6924 2C51.6924 2 52.2844 14.0244 55.0077 16.6893C57.5147 19.1424 63 19.5669 63 19.5669C63 19.5669 56.9465 20.1406 55.0077 23.3145C52.1364 28.0149 52.5508 37 52.5508 37C52.5508 37 52.5508 27.8476 49.4131 23.3145C47.059 19.9134 40 20.2424 40 20.2424Z",
    stroke: "white",
    strokeWidth: 2.65,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthStar);
export default __webpack_public_path__ + "static/media/north-star.c7fb338a9f73b5413a4e49ec70661ac0.svg";
export { ForwardRef as ReactComponent };